const types = {
  FETCH_PROFILES: '@leia/FETCH_PROFILES',
  FETCH_PROFILES_SUCCESS: '@leia/FETCH_PROFILES_SUCCESS',
  FETCH_PRESSETS: '@leia/FETCH_PRESSETS',
  FETCH_PRESSETS_SUCCESS: '@leia/FETCH_PRESSETS_SUCCESS',
};

export default types;
